<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort style="min-width: 765px;" #sort1="matSort">
                <ng-container matColumnDef="payCtrNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 120px">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 85px">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyKeitai.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 85px">入金形態</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyKeitai.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyRepay.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 80px">入金／返金</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyRepay.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="claimMny">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">請求金額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.claimMny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="inmny">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">入金額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.inmny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="trnfFee">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">振込手数料[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.trnfFee | number }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 80px">入金年月日</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyYearmonthdate | dateString }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol">
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-end tw-items-center tw-content-center">
            <div class="table-footer" style="overflow: auto;">
                <table mat-table [dataSource]="footerDataSource" style="min-width: 160px;">
                    <ng-container matColumnDef="kubun">
                        <th mat-header-cell class="border-bottom-double border-right-double text-center"
                            *matHeaderCellDef style="min-width: 30px">
                            区分</th>
                        <td mat-cell mat-header-cell *matCellDef="let row" class="border-right-double text-center">
                            {{ row.kubun }}</td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="kensu">
                        <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                            style="min-width: 25px">件数</th>
                        <td mat-cell *matCellDef="let row" class="text-right">
                            {{ row.kensu | number }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="mny">
                        <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                            style="min-width: 105px">金額[円]</th>
                        <td mat-cell *matCellDef="let row" class="text-right">
                            {{ row.mny | number }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef>
                            <mat-form-field appearance="fill" class="in-cell">
                                <mat-label>合計入金額</mat-label>
                                <input matInput readonly="true" value="{{ getSum('inmny') | number }}"
                                    class="font-color-display-only text-right" disabled>
                                <span matSuffix class="font-color-display-only" style="margin-left: .3em;">円</span>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedFooterColumnsCol"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedFooterColumnsCol"></tr>
                    <tr mat-footer-row *matFooterRowDef="displayedFooterColumnsCol"></tr>
                </table>
            </div>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <button type="button" (click)="onClickCancel()" mat-raised-button *ngIf="mode != MODE_APPROVE"
                    color="primary" class="btn" [disabled]="!this.isApprovalRequestStat">締め取消</button>
                <button type="button" (click)="onClickRegist()" mat-raised-button *ngIf="mode != MODE_APPROVE"
                    color="primary" class="btn" [disabled]="!this.isUncompletedStat">入金締め</button>
                <button type="button" (click)="onClickApproval()" mat-raised-button *ngIf="mode == MODE_APPROVE"
                    color="primary" class="btn" [disabled]="!this.isApprovalRequestStat">承認</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>